export default __webpack_public_path__ + "cff342fbb6f7da68eb9be6cf7cbf7926.png";